import { Component, inject } from '@angular/core';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-preview-breadcrumbs',
    templateUrl: './preview-breadcrumbs.component.html',
    styleUrls: ['./preview-breadcrumbs.component.css'],
    standalone: true,
    imports: [
    NgClass
],
})
export class PreviewBreadcrumbsComponent {
  public msfps = inject(MultiSectionFormPreviewService);
}
